import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Button, Tooltip } from 'wix-style-react'
import HelpIcon from 'react-icons/lib/fa/question'
import CloseIcon from 'react-icons/lib/fa/close'

import ControlledToggleSwitch from '../../shared/ControlledToggleSwitch'
import { getCustomStylesById } from 'utils/appUtils'
import { updateCustomStyleEffect } from 'controllers/logic'
import { HIDDEN } from 'constants/stylePresetType'
import { BLUE } from '../../styles'

const TopBar = styled.div`
  height: 3em;
  width: 100%;
  padding: 0 0.75em 0 1.15em;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  background-color: ${BLUE};
  cursor: move;
`
const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  & button {
    margin-left: 5px;
  }
`
const Text = styled.div`
  color: #FFF;
  font-size: 0.9em;
`
const SwitchContainer = styled.div`
  margin: 3px 15px 0 20px;
  position: relative;
  display: none;
`
const SwitchLabel = styled.div`
  text-align: center;
  font-size: 12px;
  line-height: 130%;
  color: #fff;
`

class PopoverHeader extends Component {

  hiddenPreset = null
  hiddenSwitchValue = false

  componentWillReceiveProps (nextProps) {
    const { field, app } = nextProps

    if (field && field.stylePresets) {
      this.hiddenPreset = field.stylePresets.find(preset => (preset.presetType === HIDDEN))

      if (this.hiddenPreset) {
        const customStyles = getCustomStylesById(app, this.hiddenPreset.className)
        if (customStyles[HIDDEN]) {
          this.hiddenSwitchValue = customStyles[HIDDEN].value
        }
      }
    }
  }

  switchHidden = (value) => {
    const { dispatch, app } = this.props
    dispatch(updateCustomStyleEffect(
      app,
      this.hiddenPreset.className,
      HIDDEN,
      { value }
    ))
  }

  render () {
    const { title, helpTooltip, additionalBlock, onClose } = this.props

    return ( // Using .editor-popover-top class for Draggable component
      <TopBar className='editor-popover-top'>
        <Text className='editor-popover-top'>{this.props.headingDescriptor}{title}</Text>
        <Buttons className='editor-popover-top'>
          {additionalBlock}
          {(this.hiddenPreset) &&
            <SwitchContainer>
              <SwitchLabel>Hidden</SwitchLabel>
              <ControlledToggleSwitch size='small' onChange={this.switchHidden} initialValue={this.hiddenSwitchValue} />
            </SwitchContainer>
          }

          <Tooltip
            content={helpTooltip}
            onClickOutside={null}
            onShow={() => null}
            shouldCloseOnClickOutside
            placement='top'
          >
            <Button height='small' theme='icon-whitesecondary'>
              <HelpIcon />
            </Button>
          </Tooltip>

          <Button height='small' theme='icon-whitesecondary' onClick={onClose}>
            <CloseIcon />
          </Button>
        </Buttons>
      </TopBar>
    )
  }
}

PopoverHeader.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  helpTooltip: PropTypes.string,
  additionalBlock: PropTypes.node,
  app: PropTypes.object,
  field: PropTypes.object,
  headingDescriptor: PropTypes.string
}

export default connect()(PopoverHeader)



// WEBPACK FOOTER //
// ./src/components/editor/popovers/PopoverHeader.js